/**
 * Returns a URL path without its query string or hash, e.g.
 * `/vault/1/portfolio?walletID=2#top` → `/vault/1/portfolio`.
 *
 * Pass a Next.js router's `asPath` to get the concrete page path, which
 * (unlike `router.pathname`, the route pattern) differs between two entities
 * on the same route. It is the key BreadcrumbsRouteReset uses to decide the
 * page changed, so layouts that re-publish breadcrumbs should key on it too.
 */
export function stripQueryAndHash(path: string | undefined): string {
  return (path ?? '').split(/[?#]/)[0] ?? '';
}
